import isEmpty from 'lodash/isEmpty';
import React, { Fragment } from 'react';

import StateDropDown from '../../Dropdown/State/dropdown';
import TextInput from '../../TextInput/text-input';

export default class ProvinceInput extends React.PureComponent {
	render() {
		return (
			<Fragment>
				{this.props.country && !isEmpty(this.props.country.states) ? (
					<StateDropDown
						id={`${this.props.name}State`}
						label={'State'}
						labelAfterInput={true}
						value={this.props.stateOrProvinceCode}
						onChange={this.props.onCodeChange}
						options={this.props.country.states}
					/>
				) : (
					<TextInput
						id={`${this.props.name}State`}
						label={'State'}
						labelAfterInput={true}
						placeholder="State"
						value={this.props.stateOrProvince}
						onChange={this.props.onChange}
					/>
				)}
			</Fragment>
		);
	}
}
